import React, { useState, useEffect } from 'react';

import './styles.css';

import paymentServices from '../../../../services/academy/paymentServices';

import { FaDollarSign } from 'react-icons/fa';
import ClassPaymentsCardInfo from './ClassPaymentsCardInfo';
import formatTime from '../../../../functions/formatTime';
import { Link } from 'react-router-dom';

export default function ClassPaymentsCard(props) {
    const [date, setDate] = useState(`${new Date().getFullYear()}-${formatTime(new Date().getMonth() + 1)}`);
    const [financialReport, setFinancialReport] = useState({});
    const [fetching, setFetching] = useState(true);

    useEffect(() => {
        if (props.classId)
            readFinancialReport();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.classId, date]);

    async function readFinancialReport() {
        setFetching(true);
        const auxDate = date.split('-');
        const response = await paymentServices.getFinancialReport(props.classId, auxDate[0], auxDate[1]);
        setFetching(false);
        if (response.status === 200) {
            setFinancialReport(response.data);
        } else
            alert("Erro ao ler relatório financeiro, tente novamente!");
    }

    return (
        <div className='class-page-card' id='card-payments'>
            <div className='class-card-payments-header'>
                <h4><b><FaDollarSign />Pagamentos</b></h4>
                <input
                    type="month"
                    value={date}
                    pattern="[0-9]{4}-[0-9]{2}"
                    onChange={(event) => { setDate(event.target.value) }}
                />
            </div>
            <div className="class-card-payments-infos">
                <ClassPaymentsCardInfo
                    tittle='Somatório'
                    data={financialReport.faturamento !== undefined && fetching === false ? `R$ ${String(financialReport.faturamento.toFixed(2)).replace('.', ',')}` : null}
                />
                <Link to='/academia/alunos?inadimplentes'>
                    <ClassPaymentsCardInfo tittle='Alunos inadimplentes' data={financialReport.inadimplentes} button />
                </Link>
            </div>
        </div>
    )
}